module.exports = __webpack_public_path__ + "img/general-support.84240af6.svg";